import { Component } from 'src/utils';
import template from './recent-order.html';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import shippingOfferAvailableIcon from './../../../images/shipping-tick.png';

@Component({
  controllerAs: 'recentOrder',
  template
})

export default class RecentOrder {
  static $inject = [
    '$scope',
    '$ngRedux',
    'spinnerService',
    'orderService',
    'orderActions',
    'authService',
    '$state',
    'toaster',
    '$cookies',
    '$stateParams',
    '$window',
    'APP'
  ];

  constructor($scope, $ngRedux, $spinner, $order, orderActions, $auth, $state, toaster, $cookies, $stateParams, $window, APP) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    this.orderFetched = false;
    this.$order = $order;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.$state = $state;
    this.$auth = $auth;
    this.toaster = toaster;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.APP = APP;
    this.showGotoCart = [];
    this.shippingOfferAvailableIcon = shippingOfferAvailableIcon;
   try {
          sessionStorage.removeItem('discountCoupon');
          sessionStorage.removeItem('discountCouponAmount');
          sessionStorage.removeItem('birdbuckCoupon');
          sessionStorage.removeItem('erplyBBDiscount');
          sessionStorage.removeItem('erplyBBCouponCodes');
          sessionStorage.removeItem('erplyPromotionCodes');
          sessionStorage.removeItem('erplyPromotionDiscount');
          sessionStorage.removeItem('orderNotesSession');
        }
        catch (e) {
          $cookies.remove('discountCouponAmount');
          $cookies.remove('discountCoupon');
          $cookies.remove('birdbuckCoupon');
          $cookies.remove('erplyBBDiscount');
          $cookies.remove('erplyBBCouponCodes');
          $cookies.remove('erplyPromotionCodes');
          $cookies.remove('erplyPromotionDiscount');
          $cookies.remove('orderNotesSession');
        }

    $ngRedux.dispatch(orderActions.setRecentOrder([]));
    $spinner.show('appSpinner');
    $order.getRecentOrder()
      .finally(() => {
        this.orderFetched = true;
        $spinner.hide('appSpinner');
      });

    $scope.$on('$destroy', disconnect);
  }

  mapState(state) { 
    return {
      profile: state.auth.profile,
      recentOrder: state.order.recentOrder
    };
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  ReOrder(orderId) {
    this.showGotoCart[orderId] = false;
    this.$order.reOrder(orderId)
    .then(
      success => {
        this.$auth.getUserProfile();
        if (success.data.successCode === '200') {
          // this.$state.go('cart');
          this.showGotoCart[orderId] = true;
        }
        else {
          this.toaster.pop('success', 'There is a problem retrieving data. Please add order manually.');
        }
      },
      error => {
        this.$auth.printCustomerGenericLogs(error);
      } // console.log(error)
    ).catch(err => {
      this.$auth.printCustomerGenericLogs(err);
    })
    .finally(() => {} // console.log('error')
  );
  }

  gotoCart(orderId) {
    this.showGotoCart[orderId] = false;
    this.$state.go('cart');
  }
  subscribeNow(order){
  this.$auth.resetSubscriptionCart();
  this.$auth.saveSubscriptionLocalState({});
  this.$state.go('subscription-detail',{subscriptionId:order.orderId,option:'add'});
  }

  goToProductPage(item) {

    let storeName = '';
    if(this.$stateParams.storeName) {
      storeName = this.$stateParams.storeName;
    }
    else {
      if(this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
       storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    // let storeName =  false;
    if (storeName) {
      this.$state.go('browse-product.detail', {
        categoryId: item.masterProduct.category.prettyUrl, 
        subCategoryId: item.masterProduct.subCategories[0].prettyUrl, 
        productId: item.masterProduct.prettyUrl,
        itemGroupNumber: item.masterProduct.itemGroupNumber,
        storeName: storeName
       });
    }
    else {
      this.$state.go('browse-product.detail', {
        categoryId: item.masterProduct.category.prettyUrl, 
        subCategoryId: item.masterProduct.subCategories[0].prettyUrl, 
        productId: item.masterProduct.prettyUrl,
        itemGroupNumber: item.masterProduct.itemGroupNumber
       });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/order/recent-order/recent-order.js